import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#12486c",
        secondary: "#424242",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#12486c",
        success: "#4CAF50",
        warning: "#FFC107",
      },
      dark: {
        primary: "#12486c",
        info: "#2582bf",
      }
    },
  },
});
